import api from '@/api';
import isEmpty from 'lodash/isEmpty';

const requestType = {
    SINGLE: 'single',
    MULTIPLE: 'multiple',
};

/*
    Содержит информацию по данным ГИС (для формирования отчетов)
*/

/*
    Ошибки обрабатываются, но игнорируются

    Эта модель очень похожа на rigisResidue.
    TODO: требуется унификация.
*/
export const gisReportModel = {
    name: 'gisReport',
    state: {
        gis: {},
        /*
            Поле для ошибок, пока не используется, так как ошибки игнорируются в текущей реализации
        */
        gisErrors: {
            // [wellID]: { ERROR }
        },
        /*
            В текущей реализации ключ на индикацию загрузки - один, так как данные отображаются все вместе в одной таблице.
            Когда дело дойдет до отрисовки - надо будет изменить подход.
        */
        isLoading: false,
    },
    reducers: {
        setIsLoading(state, payload) {
            return { ...state, isLoading: payload };
        },
        /*
            Payload может быть либо объектом, либо массивом с несколькими значениями
        */
        setGis(state, payload) {
            let newGis = {};

            if (Array.isArray(payload)) {
                const result = payload.reduce((acc, item) => {
                    acc[item.wellID] = item.data;
                    return acc;
                }, {});

                newGis = result;
            } else {
                const { wellID, data } = payload;
                newGis = { [wellID]: data };
            }

            return {
                ...state,
                gis: Object.assign({}, state.gis, newGis),
            };
        },
    },
    effects: () => ({
        /*
            Метод запускает инициализацию данных для отрисовки таблицы GIS;

            * Для одиночной скважины
            * Для группы скважин

            Помимо запросов на получение данных, происходит проверка на существование данных в текущей модели.
            Если данные присутствуют, запроса не происходит.
        */
        async init(_, rootState) {
            const { isGroup, activeTabletId, activeGroupIds } = rootState.tablets;
            const { gis } = rootState.gisReport;

            if (activeTabletId) {
                if (activeTabletId in gis) {
                    // Пока оставить для логирования
                    console.log(`%c${activeTabletId} without request for gis report`, 'color: green');
                    return;
                }

                try {
                    const response = await this.loadGisReport({ type: requestType.SINGLE, payload: activeTabletId });
                    this.setGis(response);
                } catch (error) {
                    console.log(error.message || 'getGisReport error');
                    this.setIsLoading(false);
                }
            }

            if (isGroup) {
                /*
                    Отбрасываем все существующие в состоянии ids.

                    Отсутствие id в состоянии может быть вызвано следующим:
                    - данные еще не запрашивали
                    - при получении данных была ошибка
                */
                const filteredExistingIDs = activeGroupIds.filter(activeID => !(activeID in gis));

                if (isEmpty(filteredExistingIDs)) return;

                const multiResponse = await this.loadGisReport({
                    type: requestType.MULTIPLE,
                    payload: filteredExistingIDs,
                });

                const result = filterMultiResponse(multiResponse);
                result && this.setGis(result);
            }
        },
        async getGisReport(wellID) {
            // Пока оставить для логирования
            console.log(`%c${wellID} with request for gis report`, 'color: red');

            const requestBody = { well: wellID, typeReport: 'loggingData' };

            try {
                const response = await api.carottage.fetchRigisData(requestBody);
                /*
                    Если данных нет (пустой массив), возвращается null для удобства проверок в дальнейшем;
                */
                return { wellID, data: response && !isEmpty(response) ? response : null };
            } catch (error) {
                // eslint-disable-next-line no-undef
                return Promise.reject(error);
            }
        },
        async getGisReportAll(wellIDs) {
            // eslint-disable-next-line no-undef
            const multiResponse = await Promise.allSettled(
                wellIDs.map(wellID => {
                    return this.getGisReport(wellID);
                })
            );

            return multiResponse;
        },
        /*
            В зависимости от конфигурации параметра opts, метод решает, какой запрос делать.
            Так же все запросы отслеживаются флагом isLoading.

            Сделано так, чтобы методы получения данных можно было переиспользовать без связей с этой моделью.
        */
        async loadGisReport(opts) {
            const { type, payload } = opts;
            let response;

            this.setIsLoading(true);

            if (type === requestType.SINGLE) {
                response = await this.getGisReport(payload);
            }

            if (type === requestType.MULTIPLE) {
                response = await this.getGisReportAll(payload);
            }

            this.setIsLoading(false);
            return response;
        },
    }),
};

/*
    Метод, который фильтрует данные после вызова Promise.all.
    Отбрасывает все ошибки и возвращает данные в виде, удобном для добавления в состояние.
*/
function filterMultiResponse(multiResponse) {
    const filteredMultiResponse = multiResponse
        .filter(response => response.status === 'fulfilled')
        .map(successResponse => successResponse.value);

    return isEmpty(filteredMultiResponse) ? null : filteredMultiResponse;
}
